import {StatusBar} from 'react-native';

import platformConfig from '/config/platform.config';

export const setDarkText = () => {
  if (platformConfig.getOS() === 'android') {
    StatusBar.setTranslucent(true);
    StatusBar.setBackgroundColor('transparent');
  }
  StatusBar.setBarStyle('dark-content');
};

export const setLightText = () => {
  if (platformConfig.getOS() === 'android') {
    StatusBar.setTranslucent(true);
    StatusBar.setBackgroundColor('transparent');
  }
  StatusBar.setBarStyle('light-content');
};

export const setWhiteBackground = () => {
  if (platformConfig.getOS() === 'android') {
    StatusBar.setBackgroundColor('white');
  }
};
